module.exports = __webpack_public_path__ + "static/narrow-f57089d77567906aa82d34aabfd277b8.png";